import React, { FC, ReactNode } from "react";

interface SectionCardProps {
  title?: ReactNode;
  eyebrow?: string;
  extra?: ReactNode;
  padded?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children: ReactNode;
}

// White surface with hairline + rest shadow — replaces the ad-hoc pastel
// Cards on quick-view screens. Tokens: docs/pms-design-system.md.
const SectionCard: FC<SectionCardProps> = ({
  title,
  eyebrow,
  extra,
  padded = true,
  className,
  style,
  children,
}) => (
  <div
    className={[
      "pms-section-card",
      padded ? "pms-section-card--padded" : "",
      className || "",
    ]
      .filter(Boolean)
      .join(" ")}
    style={style}
  >
    {(title || eyebrow || extra) && (
      <div className="pms-section-card-head">
        <div>
          {eyebrow && <div className="pms-eyebrow">{eyebrow}</div>}
          {title && <h4 className="pms-section-card-title">{title}</h4>}
        </div>
        {extra}
      </div>
    )}
    {children}
  </div>
);

export default SectionCard;
